import {fulfillmentFilename} from '../../../../utils/fulfillmentFilename';
import {hasRole} from '../../../../utils/hasRole';
import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams, useLocation} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import { SplitButton } from 'primereact/splitbutton';
import axios from "axios";
import { InputText } from 'primereact/inputtext';
import download from "js-file-download";

import FulfilmentitemFormComponent from "../fulfilmentitem/FulfilmentitemFormComponent";
import FulfillmentitemListComponent from "../fulfilmentitem/FulfilmentitemListComponent";
import RetentionListComponent from "../../finance/retention/RetentionListComponent";
import RetentionFormComponent from "../../finance/retention/RetentionFormComponent";
import ReceiptRelationFulfillmentListComponent from '../../finance/receipt/ReceiptRelationFulfillmentListComponent';
import {Badge} from 'primereact/badge';

const FulfilmentListComponent = (props) => {

  const {t, fulfillmentType} = props;
  const canWriteReceipt = hasRole('ROLE_RECEIPT_WRITE');
  const canWriteRetention = hasRole('ROLE_FULFILLMENT_WRITE') || hasRole('ROLE_PROJECT_WRITE');
  const canWriteFulfillment = hasRole('ROLE_FULFILLMENT_WRITE');
  const location = useLocation();
  const history = useHistory();
  const {entity, id} = useParams();
  const [fulfilments, setFulfilments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [receiptGroups, setReceiptGroups] = useState([]);
  const [selectedReceipt, setSelectedReceipt] = useState(null);
  const [createLoading, setCreateLoading] = useState(false);
  const [processingId, setProcessingId] = useState(null);
  const [browseType, setBrowseType] = useState(null);
  const [dialogError, setDialogError] = useState(null);
  const [showAddReceipt, setShowAddReceipt] = useState(false);
  const [statusDict, setStatusDict] = useState([])
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  const [expandedRows, setExpandedRows] = useState(null);

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams);
      if (entity === 'project') {
        query += `&search[project][operator]=%3D&search[project][value]=${id}`;
      }
      if (fulfillmentType) {
        query += `&search[type][operator]=%3D&search[type][value]=${fulfillmentType}`;
      }
      apiCall('get', '/api/v2/fulfillment' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setFulfilments(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }, Math.random() * 1000 + 250);
  };
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const downloadFulfillment = async (rowData, format) => {
    setLoading(true);
    try {
      const fulfillmentId = rowData.id;
      const res = await axios.get(
        process.env.REACT_APP_API_HOST + `/api/v2/fulfillment/${fulfillmentId}/download/${format}`,
        {
          responseType: 'blob',
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        }
      );
      download(res.data, fulfillmentFilename(rowData, format));
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error?.response);
    } finally {
      setLoading(false);
    }
  };

  const extractApiError = (error) => {
    const data = error?.response?.data;
    if (!data) return error?.toString?.() || 'Ismeretlen hiba';
    if (typeof data.detail === 'string') return data.detail;
    if (typeof data.message === 'string') return data.message;
    if (Array.isArray(data.violations) && data.violations.length) {
      return data.violations.map(v => `${v.propertyPath}: ${v.message}`).join('\n');
    }
    try { return JSON.stringify(data); } catch (e) {}
    return 'Hiba történt';
  };

 const createRelation = (mode, fulfillmentId) => {
    setDialogError(null);
    const rid = Number(selectedReceipt?.id);
    // if (!rid) { 
    //     setDialogError('Válassz ki egy számlát!'); 
    //     return; 
    // }
    const payload = { 
        parent: rid, 
        fulfillment: fulfillmentId 
    };
    setCreateLoading(true);
    apiCall('post', '/api/v2/receipt-relation', payload)
      .then(() => {
        window.App.toastShow('success', 'Sikeres mentés!');
        window.App.setState({ rerenderReceiptRelationFulfillmentList: Math.random() });
        loadLazyData();
        setSelectedReceipt(null);
        setShowAddReceipt(false);
        const cleanPath = window.location.hash.split('?')[0].replace('#', '');
        history.push(cleanPath); 
      })
      .catch((error) => {
        setDialogError(extractApiError(error));
      })
      .finally(() => setCreateLoading(false));
  };

  const openBrowse = (type) => {
    setBrowseType(type);
    const basePath = history.location.pathname;
    const params = new URLSearchParams(history.location.search);
    params.set('search', type === 'receipt' ? 'receiptRelationReceipt' : 'receiptRelationInvDoc');
    history.push(`${basePath}?${params.toString()}`);
  };

  const handleClose = (id) => {
    apiCall('get', `/api/v2/fulfillment/${id}/close`)
      .then(() => {
        window.App.toastShow('success', t('Siker'), t('A teljesítés lezárásra került.'));
        loadLazyData();
        window.App.setState({rerenderRetentionList: Math.random()});
      })
      .catch(error => {
        window.App.toastShow('error', t('Hiba'), extractApiError(error), '', error.response);
      })
  }

  const createReceipt = (fulfillmentId, groupId) => {
    setLoading(true);
    apiCall('post', `/api/v2/fulfillment/${fulfillmentId}/create-receipt/${groupId}`)
      .then(response => {
        const receipt = response.data.data;
        console.log("Bizonylat sikeresen létrejött:", receipt.id);
        history.push(`/project/project/read/${id}?update=receipt&receiptId=${receipt.id}&receiptgroupId=${groupId}`);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString());
      })
      .finally(() => setLoading(false));
  };

  const actionBodyTemplate = (rowData) => {
    const isEditable = ['draft', 'ready'].includes(rowData?.status?.toLowerCase());
    const receiptItems = receiptGroups.map(group => ({
      label: group.label,
      icon: 'pi pi-file',
      command: () => createReceipt(rowData.id, group.id)
    }));
    return (
      <React.Fragment>
        {/* {canWriteFulfillment &&
          <Button icon="pi pi-exclamation-triangle" className="p-button-secondary p-mr-2"
                  tooltip="Visszatartás" tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    history.push('/project/project/' + action + '/' + id + '?create=retention&fulfillmentId=' + rowData.id)
                  }}/>
        } */}
        {canWriteFulfillment && isEditable &&
        <>
        <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                onClick={() => {
                  // history.push('/project/fulfilment/update/' + rowData.id)
                  history.push('/project/project/read/' + id + '?update=fulfilment&fulfilmentId=' + rowData.id)
                }}/>
                {rowData.status === 'draft' && <Button
                  icon="pi pi-check" className="p-button-info p-mr-2"
                  tooltip="Készre állítás" tooltipOptions={{position: 'left'}}
                  onClick={() => apiCall('post', `/api/v2/fulfillment/${rowData.id}/ready`)
                    .then(() => { loadLazyData(); window.App.setState({rerenderProjectPage: Math.random()}); })
                    .catch(error => window.App.toastShow('error', t('Hiba'), extractApiError(error), '', error.response))}
                />}
                {rowData.status === 'ready' && <span title={rowData.can_close ? 'Lezárás' : 'A lezáráshoz kiállított vagy csatolt számla szükséges.'}>
                  <Button icon="pi pi-lock" className="p-button-success p-mr-2"
                    disabled={!rowData.can_close} tooltip="Lezárás" tooltipOptions={{position: 'left'}}
                    onClick={() => handleClose(rowData.id)} />
                </span>}
          </>
        }
        <Button icon="pi pi-file-pdf" className="p-button-secondary p-mr-2"
                tooltip={t('downloadPdf')} tooltipOptions={{position: 'left'}}
                onClick={() => downloadFulfillment(rowData, 'pdf')} 
          />
          
          <Button icon="pi pi-file-excel" className="p-button-secondary p-mr-2"
                  tooltip={t('downloadXlsx')} tooltipOptions={{position: 'left'}}
                  onClick={() => downloadFulfillment(rowData, 'xlsx')} 
          />
        {canWriteFulfillment && isEditable &&
        <>
          {canWriteReceipt && fulfillmentType === 'MAIN_CONTRACTOR' && receiptGroups.length > 0 && rowData.receipt === null && (
            <SplitButton 
              icon="pi pi-plus" 
              model={receiptItems}
              className="p-button-success p-mr-2"
              tooltip={t('documentIssue')}
              tooltipOptions={{position: 'left'}}
              onClick={() => createReceipt(rowData.id, receiptGroups[0].id)}
            />
          )}
        </>
      }
        {canWriteFulfillment && isEditable &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      apiCall('delete', `/api/v2/fulfillment/${rowData.id}`)
                        .then(() => {
                          window.App.toastShow('success', t('Siker'), t('A teljesítés törlésre került.'));
                          loadLazyData();
                          window.App.setState({
                            rerenderFulfilmentList: Math.random(),
                            rerenderProjectPage: Math.random()
                          });
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('Hiba'), error.toString(), '', error.response);
                        });
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  const renderCurrencyTotals = (totalsMap) => {
    if (!totalsMap || totalsMap.size === 0) return null;
    const priority = ['HUF', 'EUR'];
    const entries = Array.from(totalsMap.entries()).sort(([a], [b]) => {
      const ai = priority.indexOf(a);
      const bi = priority.indexOf(b);
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return String(a).localeCompare(String(b));
    });
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-end' }}>
        {entries.map(([currency, sum]) => (
          <div key={currency} style={{ whiteSpace: 'nowrap' }}>
            {(window?.App?.currencyFormatter
              ? window.App.currencyFormatter(currency, sum)
              : `${sum} ${currency}`)}
          </div>
        ))}
      </div>
    );
  };

  const totalsByNetAmount = React.useMemo(() => {
    const map = new Map();
    (fulfilments || []).forEach(row => {
      const currency = row?.currency || 'HUF';
      const amount = Number(row?.net_amount);
      if (Number.isFinite(amount)) {
        map.set(currency, (map.get(currency) || 0) + amount);
      }
    });
    return map;
  }, [fulfilments]);

  const totalsByGrossAmount = React.useMemo(() => {
    const map = new Map();
    (fulfilments || []).forEach(row => {
      const currency = row?.currency || 'HUF';
      const amount = Number(row?.gross_amount);
      if (Number.isFinite(amount)) {
        map.set(currency, (map.get(currency) || 0) + amount);
      }
    });
    return map;
  }, [fulfilments]);

  const totalsByVatAmount = React.useMemo(() => {
    const map = new Map();
    (fulfilments || []).forEach(row => {
      const currency = row?.currency || 'HUF';
      const amount = Number(row?.vat_amount);
      if (Number.isFinite(amount)) {
        map.set(currency, (map.get(currency) || 0) + amount);
      }
    });
    return map;
  }, [fulfilments]);

  const netFooter = React.useMemo(() => renderCurrencyTotals(totalsByNetAmount), [totalsByNetAmount]);
  const grossFooter = React.useMemo(() => renderCurrencyTotals(totalsByGrossAmount), [totalsByGrossAmount]);
  const vatFooter = React.useMemo(() => renderCurrencyTotals(totalsByVatAmount), [totalsByVatAmount]);

  const nameBodyTemplate = (rowData) => {
    return <strong>{rowData.name}</strong>;
  };

  const statusFilterTemplate = (options) => {
    const statusOptions = (statusDict || []).map(item => ({
      label: item.value,
      value: item.key
    }));
    return (
      <Dropdown
        value={options.value}
        options={statusOptions}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={t('selectPlaceholder')}
        showClear
        appendTo={document.body}
        className="p-column-filter"
      />
    );
  };

  const statusBodyTemplate = (rowData) => {
    const statusKey = rowData?.status?.toUpperCase();
    const foundStatus = statusDict?.find(s => s.key?.toUpperCase() === statusKey);
    const statusLabel = foundStatus ? foundStatus.value : rowData?.status || '-';
    return (
      <Badge
        value={statusLabel}
        severity={
          statusKey === 'CLOSED' ? 'success' :
          statusKey === 'DELETED' ? 'danger' :
          statusKey === 'READY' ? 'info' :
          statusKey === 'DRAFT' ? 'warning' :
          'info'
        }
      />
    );
  };

  useEffect(() => {
    let url = '/api/v2/receipt-group';
    if (fulfillmentType === 'MAIN_CONTRACTOR') {
      url += '?search[receipt_type][operator]==&search[receipt_type][value]=CUSTOMER_INVOICE';
      url += '&search[external][operator]==&search[external][value]=false';
    }
    apiCall('get', url)
      .then(response => {
        const items = response?.data?.data?.items || [];
        const filtered =
          fulfillmentType === 'MAIN_CONTRACTOR'
            ? items
            : items.filter(g => g?.receipt_type?.startsWith('SUPPLIER_'));

        setReceiptGroups(filtered.map(g => ({ label: g.name, id: g.id })));
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, [fulfillmentType]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const pickedId = query.get('related_receipt');

    if (pickedId && pickedId !== processingId) {
      const rid = Number(pickedId);
      setProcessingId(pickedId); 
      
      setSelectedReceipt({ id: rid, label: 'Betöltés...' });
      setShowAddReceipt(true);

      apiCall('get', `/api/v2/receipt/${rid}`)
        .then(res => {
          const item = res?.data?.data || res?.data;
          setSelectedReceipt({
            id: rid,
            label: item?.receipt_number || item?.number || `#${rid}`
          });
        })
        .catch(() => {
          setSelectedReceipt({ id: rid, label: `#${rid}` });
        })
        .finally(() => {
          const params = new URLSearchParams(location.search);
          params.delete('related_receipt');
          params.delete('search');
          params.set('create', 'receiptRelation');
          history.replace({
            pathname: location.pathname,
            search: params.toString()
          });
        });
      }
  }, [location.search, history, location.pathname, processingId]);

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/fulfillment-status')
      .then(response => setStatusDict(response.data.data));
    loadLazyData();
  }, []);

  useEffect(() => {
    loadLazyData();
    window.App.setState({rerenderProjectPage: Math.random()});
  }, [lazyParams, window.App.state.rerenderFulfilmentList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={fulfilments} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 rowExpansionTemplate={(rowData) => {
                  const isClosed = rowData?.status?.toUpperCase() === 'CLOSED' || rowData?.status?.toUpperCase() === 'DELETED';
                   return (
                     <>
                       <div className="expanded-section">
                        <h4 className="expanded-section__title">
                          <i className="pi pi-list" />
                          {t('fulfilmentItems')}
                        </h4>
                        <div className="expanded-section__content">
                          <FulfillmentitemListComponent fulfillmentId={rowData.id} fulfillmentStatus={rowData.status} fulfillmentCurrency={rowData.currency} />
                        </div>
                       <div className={"p-grid p-mt-1"}>
                         <div className={"p-col-12 p-lg-6 p-xl-6"}>
                         </div>
                         <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                           {canWriteFulfillment && <Button type="button" label={t('simplifiedItem')} icon="pi pi-plus"
                                   className="p-button-success p-button-sm p-ml-2"
                                   disabled={isClosed}
                                   onClick={() => {
                                    let _params = '?';
                                    Object.entries(window.App.urlVars()).map(([key, value]) => {
                                      _params += key + '=' + value + '&';
                                    });
                                    _params += 'create=fulfilmentitem&fulfillmentId=' + rowData.id + '&mode=simple';
                                    history.push(window.location.hash.replace('#', '') + _params);
                                  }}
                           />}
                           {canWriteFulfillment && <Button type="button" label={t('itemWithQuantity')} icon="pi pi-plus"
                                   className="p-button-success p-button-sm p-ml-2"
                                   disabled={isClosed}
                                   onClick={() => {
                                     let _params = '?'
                                     Object.entries(window.App.urlVars()).map(([key, value]) => {
                                       _params += key + '=' + value + '&'
                                     })
                                     _params += 'create=fulfilmentitem&fulfillmentId=' + rowData.id + '&mode=quantity';
                                     history.push(window.location.hash.replace('#', '') + _params)
                                   }}
                           />}
                           {canWriteFulfillment && <Button type="button" label={t('projectItemByProjectItem')} icon="pi pi-plus"
                                   className="p-button-success p-button-sm p-ml-2"
                                   disabled={isClosed}
                                   onClick={() => {
                                    let _params = '?';
                                    Object.entries(window.App.urlVars()).map(([key, value]) => {
                                      _params += key + '=' + value + '&';
                                    });
                                    _params += 'create=fulfilmentitem&fulfillmentId=' + rowData.id + '&mode=project';
                                    history.push(window.location.hash.replace('#', '') + _params);
                                  }}
                           />}
                           <Dialog visible={canWriteFulfillment && (window.App.urlVars().create === 'fulfilmentitem' || window.App.urlVars().update === 'fulfilmentitem')}
                                   style={{width: '980px'}}
                                  header={window.App.urlVars().update === 'fulfilmentitem' ? t('updateFulfilmentItem') : t('addFulfilmentItem')}
                                   modal
                                   onHide={() => {
                                     history.go(-1)
                                   }}>
                             <FulfilmentitemFormComponent/>
                           </Dialog>
                         </div>
                       </div>
                       </div>
                       <hr/>
                       <div className="expanded-section expanded-section--retention">
                        <h4 className="expanded-section__title">
                          <i className="pi pi-lock" />
                          {t('retentions')}
                        </h4>
                        <div className="expanded-section__content">
                          <RetentionListComponent fulfillmentId={rowData.id} fulfillmentStatus={rowData.status} fulfillmentCurrency={rowData.currency} />
                        </div>
                       <div className={"p-grid p-mt-1"}>
                         <div className={"p-col-12 p-lg-6 p-xl-6"}>
                         </div>
                         <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                           {canWriteRetention && <Button
                              type="button"
                              label={t('addRetention')}
                              icon="pi pi-plus"
                              disabled={isClosed}
                              className="p-button-success p-ml-2"
                              onClick={() => {
                                history.push(`/project/project/read/${id}?create=retention&fulfillmentId=${rowData.id}`);
                              }}
                            />}
                           <Dialog visible={canWriteRetention && (window.App.urlVars().create === 'retention' || window.App.urlVars().update === 'retention')}
                                   style={{width: '980px'}}
                                   header={t('addRetention')}
                                   modal
                                   onHide={() => {
                                     history.go(-1)
                                   }}>
                             <RetentionFormComponent />
                           </Dialog>
                         </div>
                       </div>
                       </div>
                       <div className="expanded-section expanded-section--receipt">
                        <h4 className="expanded-section__title">
                          <i className="pi pi-file" />
                          {t('receipts')}
                        </h4>
                        <div className="expanded-section__content">
                          <ReceiptRelationFulfillmentListComponent
                            fulfillmentId={rowData.id}
                          />
                        </div>
                       <div className={"p-grid p-mt-1"}>
                         <div className={"p-col-12 p-lg-6 p-xl-6"}>
                         </div>
                         {canWriteFulfillment && canWriteReceipt && !isClosed && (
                         <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                           <Button type="button" label={t('addReceipt')} icon="pi pi-plus"
                                   className="p-button-success p-ml-2"
                                   onClick={() => setShowAddReceipt(true)}
                           />
                           <Dialog
                              header={t('addReceipt')}
                              visible={showAddReceipt || window.App.urlVars().create === 'receiptRelation'}
                              style={{ width: '650px' }}
                              modal
                              onHide={() => { 
                                setShowAddReceipt(false);
                                if (window.App.urlVars().create) {
                                    history.push(history.location.pathname); 
                                }
                                setDialogError(null); 
                              }}
                              footer={
                                <div className="p-d-flex p-jc-end">
                                  <Button
                                    label={t('save')}
                                    icon={"pi pi-check"}
                                    className="p-button-success p-ml-2"
                                    loading={createLoading}
                                    disabled={!selectedReceipt?.id}
                                    onClick={() => createRelation('receipt', rowData.id)}
                                  />
                                </div>
                              }
                            >
                              <div className="p-fluid">
                                <label className="p-d-block p-mb-2">{t('fieldBrowseDocument')}</label>
                                <div className="p-inputgroup">
                                  <InputText
                                    value={selectedReceipt?.label || ''}
                                    placeholder={t('noneSelected')}readOnly
                                  />
                                  <Button
                                    type="button"
                                    icon="pi pi-search"
                                    onClick={() => openBrowse('receipt')}
                                  />
                                </div>
                                {dialogError && (
                                  <pre className="p-mt-3" style={{ whiteSpace: 'pre-wrap', color: 'var(--red-500)' }}>
                                    {dialogError}
                                  </pre>
                                )}
                              </div>
                            </Dialog>
                         </div>
                         )}
                       </div>
                       </div>
                     </>
                   )
                 }}
                 dataKey="id"
                 expandedRows={expandedRows}
                 onRowToggle={(e) => {
                  const rows = e.data;
                  if (!rows || Object.keys(rows).length === 0) {
                    setExpandedRows(null);
                    return;
                  }
                  const id = Object.keys(rows)[0];
                  setExpandedRows({[id]: true});
                }}
                 onRowExpand={(e) => {
                   let id = e.data.id
                   setExpandedRows({[id]: true})
                 }}
      >
        <Column field="serial" header={t('columnSerialNumber')} sortable></Column>
        <Column field="final" header={t('columnFinal')} sortable body={(rowData) => {
          return rowData.final ? t('yes') : t('no');
        }}></Column>
        <Column field="name" header={t('columnName')} sortable body={nameBodyTemplate}></Column>
        <Column field="status" header={t('columnStatus2')} sortable filter filterElement={statusFilterTemplate} body={statusBodyTemplate} />
        {canWriteReceipt && fulfillmentType === 'SUBCONTRACTOR' && (
          <Column field="contract.name" sortField="contract_name" header={t('columnContract')} sortable></Column>
        )}
        <Column field="issue_date" header={t('columnFulfillmentDate')} sortable body={(rowData) => {
          return rowData.issue_date ? window.App.formatDateValue(rowData.issue_date) : '';
        }}></Column>
        <Column field="partner.name" header={t('columnPartner')} sortable filter filterField="partner_name"
        ></Column>
        <Column field="net_amount" header={t('columnNetValue')} sortable footer={netFooter} className={"p-text-right"}
                body={(rowData) => window.App.currencyFormatter(rowData?.currency || 'HUF', rowData.net_amount)}
        ></Column>
        <Column field="vat_amount" header={t('columnVatValue')} sortable footer={vatFooter} className={"p-text-right"}
                body={(rowData) => window.App.currencyFormatter(rowData?.currency || 'HUF', rowData.vat_amount)}  
        ></Column>
        <Column field="gross_amount" header={t('columnGrossValue')} sortable footer={grossFooter} className={"p-text-right"}
                body={(rowData) => window.App.currencyFormatter(rowData?.currency || 'HUF', rowData.gross_amount)}
        ></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
        <Column expander style={{width: '3em'}}/>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(FulfilmentListComponent);
